(ns arthur.ui.tabs
  "The open symbols, one tab each, above the stage.

  A tab is a symbol and nothing else — there is no document tab and no special
  first one, because no symbol is special. Double-clicking a symbol in the pool,
  or an instance's row in the timeline, opens it here."
  (:require [arthur.domain.clip :as clip]
            [arthur.events.playback :as pb]
            [arthur.subs.render :as render]
            [arthur.subs.ui :as sub]
            [re-frame.core :as rf]))

(defn view []
  (let [document @(rf/subscribe [::render/clip])
        tabs     @(rf/subscribe [::sub/tabs])
        open     @(rf/subscribe [::render/open])]
    [:div.tabs
     (doall
      (for [sid tabs :when (clip/symbol document sid)]
        ^{:key (str sid)}
        [:div {:class (str "tab" (when (= sid open) " on"))
               :title (str sid)
               :on-click #(rf/dispatch [::pb/open-symbol sid])}
         [:span.name (clip/symbol-name document sid)]
         (when (< 1 (count tabs))
           [:button.close {:title "close this tab"
                           :on-click (fn [^js e]
                                       (.stopPropagation e)
                                       (rf/dispatch [::pb/close-tab sid]))}
            "×"])]))]))
